<script setup lang="ts">
import { ref, onMounted } from 'vue'

const chartOptions = ref({
  chart: { stacked: true },
  stroke: { width: [0, 0, 2, 2], curve: 'smooth' },
  plotOptions: { bar: { columnWidth: '50%' } },
  fill: { opacity: [0.8, 0.8, 0.2, 1], colors: ['#4e4e4e', '#32a800', '#00b2da', '#da0000'] },
  labels: Array.from({ length: 31 }, (_, i) => `Ngày ${i + 1}`),
  markers: { size: 0 },
  xaxis: {
    type: 'category',
    // title: { text: 'Ngày trong tháng' },
  },
  yaxis: {
    title: { text: 'Lượt cài đặt' },
    min: 0,
  },
  tooltip: {
    shared: true,
    intersect: false,
    y: {
      formatter: (y) => (typeof y !== 'undefined' ? `${y.toFixed(0)} lượt cài đặt` : y),
    },
  },
})

const series = ref([
  {
    name: "TEAM A",
    type: "column",
    data: [33, 11, 19, 24, 12, 15, 31, 29, 30, 23, 17, 20, 13, 26, 14, 22, 18, 34, 16, 21, 27, 12, 28, 25, 30, 15, 29, 19, 32, 24, 20]
  },
  {
    name: "TEAM A1",
    type: "column",
    data: [17, 20, 25, 18, 11, 14, 21, 26, 24, 15, 13, 19, 20, 22, 28, 23, 17, 14, 30, 27, 15, 29, 21, 16, 13, 26, 30, 18, 22, 25, 19]
  },
  {
    name: "TEAM B",
    type: "area",
    data: [41, 44, 57, 38, 53, 33, 51, 43, 50, 39, 60, 45, 56, 48, 31, 36, 58, 42, 34, 59, 52, 46, 54, 35, 40, 55, 49, 47, 61, 37, 43]
  },
  // {
  //   name: "TEAM C",
  //   type: "line",
  //   data: [65, 32, 51, 49, 58, 43, 60, 45, 66, 52, 59, 38, 47, 41, 55, 61, 35, 64, 50, 36, 57, 62, 54, 67, 44, 63, 46, 56, 40, 53, 39]
  // }
])
</script>

<template>
  <apexchart width="100%" height="350px" type="line" :options="chartOptions" :series="series"></apexchart>
</template>

<style scoped></style>
